React = require 'react'
_ = require 'underscore'
$ = require 'jquery'
ApiError = require 'network/api-error'
Auth = require 'db/auth'
Controller = require 'controller'
CreateBoardComponent = require 'views/board-create/create-board-component'
Dialog = require 'views/lib/dialog'
{ maybeDisplayMemberLimitsError } = require 'views/board-menu/member-limits-error'
ModelLoader = require 'db/model-loader'
ModelCacheListener = require 'views/internal/model-cache-listener'
Payloads = require 'network/payloads'
Promise = require 'bluebird'
SidebarState = require 'view-models/sidebar-state'
t = require('views/internal/recup-with-helpers')('home')
trackUe = require 'debug/trackUe'
l = require 'lib/localize'
Util = require 'lib/util'

RecentBoards = require 'lib/recent-boards'
recentBoardsHelper = new RecentBoards()
HomeBoardTile = require 'views/home/home-board-tile'
HomeBoardDndContainer = require 'views/home/home-board-dnd-container'
{ BoardSection } = require './presentational/board'
{ LinkSection } = require './presentational/link'

class HomeRightSidebarContainer extends React.Component
  displayName: 'HomeRightSidebarContainer'

  constructor: (props) ->
    @defaultNumStarredBoardsVisible = 8
    @defaultNumRecentBoardsVisible = 4

    @_idBoardsFetching = []
    @currentStarBoardList = props.model.boardStarList.getBoardIds()
    @getBoardsCallbackWrapper = {}

    @state =
      starredBoards: []
      recentBoards: []
      showAllStarredBoards: false
      showAllRecentBoards: false

    @getBoards = @getBoards.bind(@)
    @showBoards = @showBoards.bind(@)
    @addBoard = @addBoard.bind(@)
    @renderBoardTile = @renderBoardTile.bind(@)
    @fetchUnknownBoardsCallback = @fetchUnknownBoardsCallback.bind(@)

  componentDidMount: ->
    @getBoards()
    @listenOnBoardListChange()

  componentWillUnmount: ->
    delete @getBoardsCallbackWrapper.value

  componentWillReceiveProps: (nextProps) ->
    newStarBoardList = nextProps.model.boardStarList.getBoardIds()
    if !_.isEqual(@currentStarBoardList, newStarBoardList)
      @getBoards()

    @currentStarBoardList = newStarBoardList

  listenOnBoardListChange: =>
    { model, modelListener } = @props

    modelListener model.boardList, 'change:closed', =>
      @getBoards()

  fetchUnknownBoardsCallback: (idBoardsMissing) ->
    { modelCache } = @props
    me = Auth.me()
    missingRecentBoards = _.chain idBoardsMissing
      .map (idBoard) => modelCache.get('Board', idBoard)
      .compact()
      .filter (board) => board?.isOpen() && board?.isViewableBy(me)
      .value()
    @setState (prevState) ->
      recentBoards: prevState.recentBoards.concat(missingRecentBoards)

  getBoards: ->
    @getBoardsCallbackWrapper = callbackWrapper = value: =>
      { model, modelCache } = @props

      me = Auth.me()

      starredBoards = _.filter(model.boardStarList.getBoards(), (board) => board?.isOpen() && board?.isViewableBy(me))
      recentBoards = recentBoardsHelper.getBoards(model, @fetchUnknownBoardsCallback)

      @setState (prevState, props) ->
        starredBoards: starredBoards
        recentBoards: recentBoards

    ModelLoader.waitFor 'boardsData', -> callbackWrapper.value?()

  showBoards: (boardType, showAll) ->
    { modelCache, orgname } = @props
    orgId = modelCache.findOne('Organization', 'name', orgname)?.id

    if boardType == 'starred'
      @setState showAllStarredBoards: showAll
    else if boardType == 'recent'
      @setState showAllRecentBoards: showAll

    moreOrFewer = if showAll then 'more' else 'fewer'
    if orgId
      trackUe('home', 'shows ' + moreOrFewer, 'boards', '', '', 'by clicking show ' + moreOrFewer + ' button in ' + boardType + ' boards list when filtered by team', { teamId: orgId })
    else
      trackUe('home', 'shows ' + moreOrFewer, 'boards', '', '', 'by clicking show ' + moreOrFewer + ' button in ' + boardType + ' boards list')

  addBoard: (e) ->
    Util.preventDefault(e)

    if maybeDisplayMemberLimitsError($(e.target), null, Auth.me())
      return

    { modelCache, orgname } = @props
    orgModel = modelCache.findOne('Organization', 'name', orgname)
    buttonName = if orgModel then 'create a team board' else 'create a board'
    @trackClick('opens', 'create board menu', buttonName)

    Dialog.show
      displayType: 'mod-no-chrome'
      opacity: 0.75
      reactElement: React.createElement CreateBoardComponent,
        defaultOrg: orgModel
        trackingOpts: { category: 'home', method: "by clicking #{buttonName} button in right sidebar" }

  trackClick: (verb, directObj, buttonName) ->
    { modelCache, orgname } = @props
    orgId = modelCache.findOne('Organization', 'name', orgname)?.id
    method =
      if orgId
      then "by clicking #{buttonName} in right sidebar when filtered by team"
      else "by clicking #{buttonName} in right sidebar"
    context = if orgId then { teamId: orgId } else {}

    trackUe('home', verb, directObj, '', '', method, context)

  renderBoardTile: (boardId, boardsType, isDraggable, orgId) =>
    React.createElement HomeBoardTile, {
      key: boardId
      modelCache: @props.modelCache
      boardId
      boardsType
      isDraggable
      orgId
    }

  render: t.renderable ->
    { model, modelCache, orgname } = @props
    {
      starredBoards
      recentBoards
      showAllRecentBoards
      showAllStarredBoards
    } = @state

    orgId = modelCache.findOne('Organization', 'name', orgname)?.id

    t.div '.home-right-sidebar-container', =>
      if starredBoards.length
        t.tag HomeBoardDndContainer, {
          boardIds: starredBoards.map((starredBoard) => starredBoard.get('id'))
          boardsType: 'starred'
          isDraggable: true
          numBoardsVisible: @defaultNumStarredBoardsVisible
          onShowFewerClick: => @showBoards('starred', false)
          onShowMoreClick: => @showBoards('starred', true)
          orgId
          @renderBoardTile
          sectionHeaderTitle: l('home board section title.starred')
          sectionHeaderIconName: 'star'
          showAll: showAllStarredBoards
        }

      if recentBoards.length
        t.tag BoardSection, {
          boardIds: recentBoards.map((recentBoard) => recentBoard.get('id'))
          boardsType: 'recent'
          numBoardsVisible: if starredBoards.length < 4 then 8 else @defaultNumRecentBoardsVisible
          orgId
          onShowFewerClick: => @showBoards('recent', false)
          onShowMoreClick: => @showBoards('recent', true)
          @renderBoardTile
          sectionHeaderTitle: l('home board section title.recent')
          sectionHeaderIconName: 'clock'
          showAll: showAllRecentBoards
        }

      links = [{
        iconName: 'add'
        isButton: true
        onClick: @addBoard
        text: if orgname then t.l('home-create-team-board') else t.l('home-create-board')
      }]

      t.tag LinkSection, {
        sectionHeaderTitle: l('home board section title.links')
        links
      }

module.exports = ModelCacheListener(HomeRightSidebarContainer)



// WEBPACK FOOTER //
// ./app/scripts/views/home/home-right-sidebar-container.coffee